import Vue from 'vue'
import Router from 'vue-router'
import Footer from '@/components/footer.vue'
import Header from '@/components/header.vue'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// const originalReplace = VueRouter.prototype.replace;
// VueRouter.prototype.replace = function replace(location) {
//     return originalReplace.call(this, location).catch(err => err);
// };

export default new Router({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		//首页
		{
			path: '/',
			name: 'Home',
			components: {
				default: () => import('../pages/Home/index.vue'),
				footer: Footer,
				header: Header
			},
			meta: {
				title: '易起飞同行天地'
			}

		},
		//登录页面
		{
			path: '/login',
			name: 'login',
			meta: {
				title: '登录易起飞同行天地'
			},
			component: () => import('../pages/login/login.vue')


		},

		//国际机票
		{
			path: '/IntlAir',
			name: 'IntlAir',
			meta: {
				title: '国际机票 易起飞同行天地'
			},
			components: {
				default: () => import('../pages/IntlAir/index.vue'),
				footer: Footer,
				header: Header
			}
		},
		{
			path: '/IntlAir/list',
			name: 'IntlAir',
			meta: {
				title: '易起飞同行天地' 
			},
			components: {
				default: () => import('../pages/IntlAir/list.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/IntlAir/comfirm',
			name: 'IntlAir',
			components: {
				default: () => import('../pages/IntlAir/comfirm.vue'),
				header: Header
			}

		},
		{
			path: '/IntlAir/booking',
			name: 'IntlAir',
			components: {
				default: () => import('../pages/IntlAir/booking.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/IntlAir/success',
			name: 'IntlAir',
			components: {
				default: () => import('../pages/IntlAir/success.vue'),
				header: Header
			}

		},
		//个人中心
		{
			path: '/Profile/Order',
			name: 'Profile',
			component: () => import('../pages/Profile/Order.vue'),
			meta: {
				title: '订单列表'
			}
		},
		{
			path: '/Profile/OrderDetail',
			name: 'Profile',
			component: () => import('../pages/Profile/OrderDetail.vue'),
			meta: {
				title: '订单详情'
			}
		},
		{
			path: '/Profile/BuildRoute',
			name: 'Profile',
			component: () => import('../pages/Profile/BuildRoute.vue'),
			meta: {
				title: '会员中心'
			}
		},
		{
			path: '/Profile/CompanyOrder',
			name: 'Profile',
			component: () => import('../pages/Profile/CompanyOrder.vue'),
			meta: {
				title: '会员中心'
			}
		},
		{
			path: '/Profile/ServiceTeam',
			name: 'Profile',
			component: () => import('../pages/Profile/ServiceTeam.vue'),
			meta: {
				title: '会员中心'
			}
		},
		{
			path: '/Profile/Cash',
			name: 'Profile',
			component: () => import('../pages/Profile/Cash.vue'),
			meta: {
				title: '会员中心'
			}
		},
		{
			path: '/Profile/Account',
			name: 'Profile',
			component: () => import('../pages/Profile/Account.vue'),
			meta: {
				title: '会员中心'
			}
		},
		{
			path: '/Profile/groupTickectOrder',
			name: 'Profile',
			component: () => import('../pages/Profile/groupTickectOrder.vue'),
			meta: {
				title: '会员中心'
			}
		},
        {
            path: '/Profile/NoticeCenter',
            name: 'Profile',
            component: () => import('../pages/Profile/NoticeCenter.vue'),
            meta: {
                title: '通知中心'
            }
        },
		//国内机票
		{
			path: '/DomesticAir',
			name: 'DomesticAir',
			components: {
				default: () => import('../pages/IntlAir/index.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/DomesticAir/booking',
			name: 'DomesticAir',
			components: {
				default: () => import('../pages/DomesticAir/booking.vue'),
				footer: Footer,
				header: Header
			}
		},
		{
			path: '/DomesticAir/list',
			name: 'DomesticAir',
			components: {
				default: () => import('../pages/DomesticAir/list.vue'),
				footer: Footer,
				header: Header
			}
		},
		{
			path: '/DomesticAir/showflight',
			name: 'DomesticAir',
			components: {
				default: () => import('../pages/DomesticAir/list.vue'),
				footer: Footer,
				header: Header
			}
		},
		{
			path: '/DomesticAir/comfirm',
			name: 'DomesticAir',
			components: {
				default: () => import('../pages/DomesticAir/comfirm.vue'),
				footer: Footer,
				header: Header
			}
		},
		//酒店
		{
			path: '/Hotel',
			name: 'Hotel',
			components: {
				default: () => import('../pages/Hotel/indexv2.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Hotel/list',
			name: 'Hotel',
			components: {
				default: () => import('../pages/Hotel/list.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Hotel/detail',
			name: 'Hotel',
			components: {
				default: () => import('../pages/Hotel/detail.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Hotel/comfirm',
			name: 'Hotel',
			components: {
				default: () => import('../pages/Hotel/comfirm.vue'),
				header: Header
			}

		},
		{
			path: '/Hotel/booking',
			name: 'Hotel',
			components: {
				default: () => import('../pages/Hotel/booking.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Hotel/success',
			name: 'Hotel',
			components: {
				default: () => import('../pages/Hotel/success.vue'),
				header: Header
			}

		},
		//系统管理
		{
			path: '/Management/Organization',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Organization.vue'),
			}
		},
		{
			path: '/Management/Home',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Home.vue'),
			}		
		},
        {
            path: '/Management/Approve',
            name: 'Management',
            components: {
                default: () => import('../pages/Management/Approve.vue'),
            }		
        },
        {
            path: '/Management/Policy',
            name: 'Management',
            components: {
                default: () => import('../pages/Management/Policy.vue'),
            }		
        },
		{
		    path: '/Management/BusinessReason',
		    name: 'Management',
		    components: {
		        default: () => import('../pages/Management/BusinessReason.vue'),
		    }		
		},
		{
		    path: '/Management/Cost',
		    name: 'Management',
		    components: {
		        default: () => import('../pages/Management/Cost.vue'),
		    }		
		},
		{
		    path: '/Management/Cost/Add',
		    name: 'Management',
		    components: {
		        default: () => import('../pages/Management/Cost/Add.vue'),
		    }		
		},
		{
		    path: '/Management/ViolateReason',
		    name: 'Management',
		    components: {
		        default: () => import('../pages/Management/ViolateReason.vue'),
		    }		
		},
		{
			path: '/Management/Policy/Add',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Policy/add.vue'),
			}

		},
		{
			path: '/Management/Employee',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Employee.vue'),
			}

		},
		{
			path: '/Management/Cash',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Cash.vue'),
			}

		},
		{
			path: '/Management/Statement',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Statement.vue'),
			}

		},
		{
			path: '/Management/Bulletin',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Bulletin.vue'),
			}

		},
		{
			path: '/Management/CompLogo',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/CompLogo.vue'),
			}

		},
		{
			path: '/Management/Approve/Add',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Approve/Add.vue'),
			}

		},
		{
			path: '/Management/Employee/Import',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Employee/Import.vue'),
			}

		},
		{
			path: '/Management/Employee/Modify',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Employee/Modify.vue'),
			}
		},
		{
			path: '/Management/Employee/WhiteImport',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Employee/WhiteImport.vue'),
			}
		},
		{
			path: '/Management/Role',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Role.vue'),
			}
		},
		{
			path: '/Management/Role/Add',
			name: 'Management',
			components: {
				default: () => import('../pages/Management/Role/Add.vue'),
			}
		},
		//欧铁
		{
			path: '/Europe',
			name: 'Europe',
			components: {
				default: () => import('../pages/Europe/index.vue'),
				footer: Footer,
				header: Header
			}
		},
		{
			path: '/Europe/list',
			name: 'Europe',
			components: {
				default: () => import('../pages/Europe/list.vue'),
				footer: Footer,
				header: Header
			}
		},
		{
			path: '/Europe/detail',
			name: 'Europe',
			components: {
				default: () => import('../pages/Europe/detail.vue'),
				footer: Footer,
				header: Header
			}
		},
		{
			path: '/Europe/booking',
			name: 'Europe',
			components: {
				default: () => import('../pages/Europe/booking.vue'),
				footer: Footer,
				header: Header
			}
		},
		{
			path: '/Europe/comfirm',
			name: 'Europe',
			components: {
				default: () => import('../pages/Europe/comfirm.vue'),
				header: Header
			}
		},
		{
			path: '/Europe/success',
			name: 'Europe',
			components: {
				default: () => import('../pages/Europe/success.vue'),
				header: Header
			}
		},

		//火车票
		{
			path: '/Train',
			name: 'Train',
			components: {
				default: () => import('../pages/Train/index.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Train/Searchs',
			name: 'Train',
			components: {
				default: () => import('../pages/Train/list.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Train/Detail',
			name: 'Train',
			components: {
				default: () => import('../pages/Train/Detail.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Train/booking',
			name: 'Train',
			components: {
				default: () => import('../pages/Train/booking.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Train/list',
			name: 'Train',
			components: {
				default: () => import('../pages/Train/list.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Train/Confirm',
			name: 'Train',
			components: {
				default: () => import('../pages/Train/Confirm.vue'),
				footer: Footer,
				header: Header
			}

		},
		//租车
		{
			path: '/RentCar',
			name: 'RentCar',
			components: {
				default: () => import('../pages/RentCar/index.vue'),
				footer: Footer,
				header: Header
			}

		},

		//保险
		{
			path: '/Insurance',
			name: 'Insurance',
			components: {
				default: () => import('../pages/Insurance/index.vue'),
				footer: Footer,
				header: Header
			}

		},

		//保险航空意外险
		{
			path: '/Insurance/list',
			name: 'Insurance',
			components: {
				default: () => import('../pages/Insurance/list.vue'),
				footer: Footer,
				header: Header
			}

		},

		//保险选择保险
		{
			path: '/Insurance/detail',
			name: 'Insurance',
			components: {
				default: () => import('../pages/Insurance/detail.vue'),
				footer: Footer,
				header: Header
			}

		},

		//保险订单填写资料
		{
			path: '/Insurance/confirm',
			name: 'Insurance',
			components: {
				default: () => import('../pages/Insurance/confirm.vue'),
				footer: Footer,
				header: Header
			}

		},

		//保险确定订单
		{
			path: '/Insurance/booking',
			name: 'Insurance',
			components: {
				default: () => import('../pages/Insurance/booking.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Insurance/orderResult',
			name: 'orderResult',
			components: {
				default: () => import('../pages/Insurance/orderResult.vue'),
				footer: Footer,
				header: Header
			}
		
		},

		//签证
		{
			path: '/Visa',
			name: 'Visa',
			components: {
				default: () => import('../pages/Visa/index.vue'),
				footer: Footer,
				header: Header
			}
		},

		//行程单
		{
			path: '/PnrOrder',
			name: 'PnrOrder',
			components: {
				default: () => import('../pages/PnrOrder/index.vue'),
				header: Header
			}

		},
		//航班时刻
		{
			path: '/FlightTime/SelectPrice',
			name: 'FlightTime',
			components: {
				default: () => import('../pages/FlightTime/SelectPrice'),
				header: Header
			}
		},
		{
			path: '/FlightTime/Flights',
			name: 'FlightTime',
			components: {
				default: () => import('../pages/FlightTime/Flights'),
				header: Header
			}
		},
		{
			path: '/FlightTime/index',
			name: 'FlightTime',
			components: {
				default: () => import('../pages/FlightTime/index'),
				header: Header
			}
		},
		//团票宝
		{
			path: '/TuanPiaoBao',
			name: 'TuanPiaoBao',
			components: {
				default: () => import('../pages/TuanPiaoBao/index.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/TuanPiaoBao/list',
			name: 'TuanPiaoBao',
			components: {
				default: () => import('../pages/TuanPiaoBao/list.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/TuanPiaoBao/detail',
			name: 'TuanPiaoBao',
			components: {
				default: () => import('../pages/TuanPiaoBao/detail.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/TuanPiaoBao/orderInfo',
			name: 'TuanPiaoBao',
			components: {
				default: () => import('../pages/TuanPiaoBao/orderInfo.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/TuanPiaoBao/success',
			name: 'TuanPiaoBao',
			components: {
				default: () => import('../pages/TuanPiaoBao/success.vue'),
				footer: Footer,
				header: Header
			}

		},
		{
			path: '/Account/registerRule',
			name: 'Account',
			components: {
				default: () => import('../pages/Account/registerRule.vue'),
				footer: Footer,
				// header: Header
			}
		},
		{
			path: '/Account/register',
			name: 'Account',
			components: {
				default: () => import('../pages/Account/register.vue'),
				footer: Footer,
				// header: Header
			}
		},
		{
			path: '/Booking/result',
			name: 'BookingResult',
			components: {
				default: () => import('../pages/Booking/result.vue'),
				header: Header
			}
		
		},
		/*测试*/
		{
			path: '/Test/demo',
			name: 'Test',
			components: {
				default: () => import('../pages/Test/Demo.vue'),				
			}
		},
	]
})
